import * as api from '../../services/bankcardVerify'

export const FETCH_BANKCARDVERIFYS= 'FETCH_BANKCARDVERIFYS';



export const fetchBankcardverifys = (params, pagination, sort, extra) => {

    return {
        type: FETCH_BANKCARDVERIFYS,
        payload: {
            promise: api.findBankcardverifys(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/bankcardVerify.js